import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import Moment from 'react-moment'
import { deleteInventory, listInventory } from '../actions/inventoryActions'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'

const InventoryUnit = ({ unit }) => {
  const dispatch = useDispatch()

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  const canManageAll = Boolean(ownerInfo || (userInfo && userInfo.isAdmin))

  const deleteItem = (id) => {
    if (window.confirm('Are you sure?')) {
      dispatch(deleteInventory(id))
      dispatch(listInventory())
      dispatch({ type: 'INVENTORY_DELETE_RESET' })
    }
  }

  const tableRowClass =
    unit.qty === 0
      ? 'inventory-out-stock'
      : unit.qty <= unit.lowinventory
        ? 'inventory-low-stock'
        : ''

  return (
    <tr className={tableRowClass}>
      <td>{unit.upc}</td>
      <td>{unit.item}</td>
      <td>{unit.manufacturer}</td>
      <td>{unit.subname}</td>
      <td>{unit.qty}</td>
      <td>{unit.lowinventory}</td>
      <td align='right'>
        {unit.cost.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        })}
      </td>
      <td align='right'>
        {unit.price.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        })}
      </td>
      <td align='right'>
        <Moment format='M/D/YY, h:mm a'>{new Date(unit.updatedAt)}</Moment>
      </td>
      {canManageAll && (
        <>
          <td>
            <LinkContainer to={`/inventory/edit/${unit._id}`}>
              <Button variant='primary' size='sm'>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            </LinkContainer>
          </td>
          <td>
            <Button
              variant='danger'
              size='sm'
              onClick={() => deleteItem(unit._id)}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </td>
        </>
      )}
    </tr>
  )
}

export default InventoryUnit
